import React from "react";

import NewHeadline from "../../../../shared/NewHeadline";
import OrderChoiceButtons from "../../../../shared/OrderChoiceButtons";
import useCalculatorStore from "../../CalculatorPage/store";
import useStepPaymentTypeStore from "./store";

const StepPaymentType = () => {
    const [additions] = useCalculatorStore((state) => [state.additions]);
    const [paymentType, setPaymentType, paymentTypeHasChanged] =
        useStepPaymentTypeStore((state) => [
            state.paymentType,
            state.setPaymentType,
            state.paymentTypeHasChanged,
        ]);

    /**
     * Check if the payment types have some additions.
     */
    const hasAdditions = () => {
        return (
            Object.keys(additions.payment_types).filter((key) => {
                return parseFloat(additions.payment_types[key].add) > 0;
            }).length > 0
        );
    };

    /**
     * When the payment type changes.
     *
     * @param {*} value
     */
    const onChange = (value) => {
        setPaymentType(value);
        paymentTypeHasChanged();
    };

    const getPaymentTypes = () => {
        return Object.keys(additions.payment_types).map((key) => {
            return additions.payment_types[key];
        });
    };

    return (
        <section>
            <NewHeadline>Zahlart</NewHeadline>
            {additions && (
                <OrderChoiceButtons
                    choices={getPaymentTypes()}
                    activeId={paymentType}
                    onChoiceChange={onChange}
                    hasSubtitle={hasAdditions()}
                />
            )}
        </section>
    );
};

export default StepPaymentType;
